export function getErrorPath(sectionId, blockRef, ref) {
    return [sectionId, blockRef, ref].filter(Boolean).join('|');
}
